import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';

export default class PayoutStatusFilter extends Component {
    static propTypes = {
        filter: PropTypes.any,
        onChange: PropTypes.func
    };

    render() {
        return (
            <select
                className="filter-input"
                onChange={(event) => this.props.onChange(event.target.value)}
                value={get(this.props, 'filter.value', '')}
            >
                <option value=""></option>
                <option value="10">PENDING PROVIDER ACTION</option>
                <option value="11">PENDING MERCHANT ACTION</option>
                <option value="12">PENDING RECIPIENT ACTION</option>
                <option value="20">COMPLETED</option>
                <option value="30">EXPIRED</option>
                <option value="40">CANCELED</option>
                <option value="50">RETURNED</option>
                <option value="90">FAILED</option>
            </select>
        );
    }
}
